module.exports = __webpack_public_path__ + "img/6.7c83a155.jpg";